export enum FEATURE_NAMES {
  AllowedToCreateNewClientCompany = "allowedToCreateNewClientCompany",
  AllowedToChangeRootCompany = "allowedToChangeRootCompany",
  AllowedToInviteAllRoles = "allowedToInviteAllRoles",
  AllowedFullControlOfUsers = "allowedFullControlOfUsers",
  AllowedGlobalScheduleLinking = "allowedGlobalScheduleLinking",
  AllowFeatureSwitches = "allowFeatureSwitches",
  CancelInvitation = "cancelInvitation",
  ChangeLanguage = "changeLanguage",
  ChangePassword = "changePassword",
  ShowSecuritySettings = "showSecuritySettings",
  CcaFileDownload = "ccaFileDownload",
  ResendInvitation = "resendInvitation",
  ShowCompanySelector = "showCompanySelector",
  ShowDashboard = "showDashboard",
  ShowFileSettingsButton = "showFileSettingsButton",
  ShowFindDevice = "showFindDevice",
  ShowNotifications = "showNotifications",
  ShowInviteUser = "showInviteUser",
  ShowToggle2FA = "showToggle2FA",
  ShowTutorials = "showTutorials",
  ShowDriversLastActivityFilter = "showDriversLastActivityFilter",
  ShowHistoryButton = "showHistoryButton",
  ShowDeleteCompanyButton = "showDeleteCompanyButton",
  ManageNews = "manageNews",
  PublishNews = "publishNews",
  ShowIntegrationsPage = "showIntegrationsPage"
}
